import { createContext, useContext } from 'react';
import type { AppNotification } from '@/types/notifications';

export interface NotificationsState {
  items: AppNotification[];
  loading: boolean;
  error: string | null;
  reload: () => void;
  markRead: (id: string) => void;
  markAllRead: () => void;
  /** Full-page list for phones; without it the bell always opens the panel. */
  pagePath?: string;
  settingsPath?: string;
}

const EMPTY: NotificationsState = {
  items: [],
  loading: false,
  error: null,
  reload: () => {},
  markRead: () => {},
  markAllRead: () => {},
};

/** Supplied by the dashboard; the bell and panel read it. Defaults to no notifications. */
export const NotificationsContext = createContext<NotificationsState>(EMPTY);
export const useNotifications = () => useContext(NotificationsContext);
